import { createActionGroup, props } from '@ngrx/store';
import { SphereAppCategory } from '@app/app-routes';

export const AppSwitcherActions = createActionGroup({
    source: 'App Switcher',
    events: {
        'Select App Category': props<{ appCategory: SphereAppCategory | 'favorites' }>()
    }
});
